'use strict';

/**
 * Define any constants that need to be used application-wide
 */

// uri for API calls
export var apiUrl = 'http://localhost:3002/react-webpack-php-starter/public/api/api.php';

export const GENERAL_CONSTANTS = {
  DATE_FORMAT: 'YYYY-MM-DD HH:mm:ss',
  DATE_DISPLAY_FORMAT: 'MMMM Do h:mm A, dddd (z)',
  DATE_V2_DISPLAY_FORMAT: 'dddd MMMM Do',
  DATE_V2_TIME: 'h:mma z',
};
